import React from 'react';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { usePerformanceSummary } from '../../hooks/usePerformanceSummary';
import { LabeledListLoading } from '../LabeledList/LabeledList.loading';
import { LabeledList } from '../LabeledList/LabeledList';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { ActivityDetailsLink } from './ActivityDetailsLink/ActivityDetailsLink';

interface PerformanceSummaryProps {
  isTransactions?: boolean;
}

export const PerformanceSummary: React.FC<PerformanceSummaryProps> = ({ isTransactions }) => {
  const { isFetching, isError, refetch, data } = usePerformanceSummary({ isTransactions });

  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isFetching) {
    return <LabeledListLoading />;
  }

  if (isError) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
        py={isEmbeddedMobile ? '48' : undefined}
      >
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={isEmbeddedMobile ? '24' : undefined}
      >
        <EmptyState />
      </Box>
    );
  }

  return (
    <>
      <LabeledList data={data} />

      <ActivityDetailsLink />
    </>
  );
};
